import { publicContactUsUrl } from "common/config";
import { useI18N } from "common/hooks";
import { cn } from "@/lib/utils";

/**
 * Last line of the "business category isn't supported" message: invites the
 * user to suggest categories or venues via the Contact Us form. Web only —
 * native keeps its own copy. Renders nothing if the form URL isn't
 * configured, rather than a dead link.
 */
export function UnsupportedCategoryContactPrompt({
  className,
}: {
  className?: string;
}) {
  const i18n = useI18N();
  if (!publicContactUsUrl) return null;

  return (
    <p className={cn("mt-1", className)}>
      {i18n.get("poiUnsupportedContactPrompt")}{" "}
      <a
        href={publicContactUsUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="focus-blue text-fg-brand-subtle underline"
      >
        {i18n.get("poiUnsupportedContactLink")}
        <span className="sr-only"> {i18n.get("opensInNewTab")}</span>
      </a>
      .
    </p>
  );
}
